<template>
  <div class="MenyCate ps-2 pe-2 container-xxl">
    <!-- Start Page Html  -->
    <!--  @click="getCurrentCategory(category.id, $event)" -->
    <div class="kategory_slider">
      <div
        class="uk-position-relative uk-visible-toggle uk-light"
        tabindex="-1"
        uk-slider="autoplay: false;autoplay-interval:5000;"
      >
        <ul
          class="
            uk-slider-items
            uk-child-width-1-2
            uk-child-width-1-3@s
            uk-child-width-1-4@m
            uk-child-width-1-6@l
          "
        >
        <!-- v-for="(category ,index) in fetchDataCategory" :key="category.id" 
        :class="{ 'active': activeItem === index }" @click="getCurrentCategory(category.id, $event , index)"
        -->
          <li v-for="(category) in this.getCate_list" :key="category.id" 
            class="single_category_top">
           
            <router-link class="item_kategg" :to="{ path: `/meny/${category.url}`}" @click.native="getCate_id(category)">
              <div class="wrap_hover_ketegory_top">
                <img
                  class="img_category_top_slider normalimg"
                  :src="category.icon"
                  alt="24order"/>
              </div>

              <span class="title_category_top_slider">{{category.name}}</span>
            </router-link>
          </li>
       
        </ul>
       
      </div>
</div>
    <!-- start Box Menu -->
  </div>
</template>
<script>
import {mapGetters , mapActions , mapMutations} from 'vuex';
export default {
  name: "cateboxApp",
  data: function () {
    return {
      activeItem:0,};
  },
  methods: {
    ...mapActions({
        change_category:'change_category'
    }),
    ...mapMutations({
      SET_DEFALUT:'SET_DEFALUT'
    }),
  
    getCate_id(cate){
      // console.log(id  , 'id compnent')
      let cate_obj = {
        'id':cate.id,
        'name':cate.name,
        'url':cate.url
      }
     this.change_category(cate_obj);
    }
  },
  computed:{
    ...mapGetters({
        getCate_list:'getCate_list',
        get_default_cate:'get_default_cate',
        
    })
  },
};
</script>

<style lang="scss"  scoped>
//kategory slider new slide
.kategory_slider{
    position: relative;
        margin-top: -20px;
    margin-bottom: 30px;
    background-color: white;
    padding-bottom: 12px;
}
.kategory_slider::before{
  content: "";
    width: 100%;
    height: 30px;
    background-color: white;
    position: absolute;
    z-index: 0;
    top: 43%;
    transform: translate(0px, -50%);
    left: 0;
    border-radius: 50px;
}
.single_category_top .router-link-active{
  .wrap_hover_ketegory_top{
   border: 5px solid #fcca34 !important;
    background-color: #feeaae !important;
    img{
       background-color: #fcca34 !important;
    }
}
.title_category_top_slider{
    color: #d09c00;
}


}
.item_kategg{
    z-index: 1;
     text-align: center;
    display: block;
    position: relative;
      &:hover{
        .wrap_hover_ketegory_top{
        border: 5px solid #fcca34 !important;
    background-color: #feeaae !important;
    img{
       background-color: #fcca34 !important;
    }
        }
     .title_category_top_slider{
    color: #d09c00;
}
    }
.wrap_hover_ketegory_top{
    border: 5px solid #fcca34;
    width: 100px;
    height: 100px;
    border-radius: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 0 auto;
    transition: 0.2s linear;
    background-color: white;
    img{
    width: 90px;
    height: 90px;
    -o-object-fit: contain;
    object-fit: contain;
    background-color: #FEEAAE;
    border-radius: 100%;
    padding: 8px;
    transition: 0.2s linear;
    transform: rotate(17deg);
    }
} 
.title_category_top_slider{
   font-size: 14px;
    font-weight: 600;
    margin-top: 0px;
    display: block;
    color: black;
}
}
// end kategory

// 
</style>